import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @fragment DealItemSaleItemPackageFragment
 * @since 1.0.0
 */
export const DealItemSaleItemPackageFragment = gql `
  fragment DealItemSaleItemPackageFragment on SaleItemPackage {
    id
    sku
    title
    infos
    active
    price
    icon
    taxable
    quantityCalculation
    deletedAt

    groups {
      id
      title
    }

    saleItems {
      id
      required
      item {
        id
        sku
        title
        infos
      }
    }

    translations {
      id
      title
      infos
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }
  }

  ${LanguageFragment}
`;
